var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepSendTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5967 23.1499C37.7649 23.2982 37.8364 23.5279 37.782 23.7455L34.582 36.5455C34.5296 36.7552 34.3684 36.9205 34.1601 36.9782C33.9518 37.0359 33.7285 36.9771 33.5757 36.8243L30.0649 33.3134L28.0799 35.96C27.946 36.1385 27.7241 36.228 27.5038 36.1922C27.2836 36.1565 27.1013 36.0014 27.0307 35.7897L25.5093 31.2255L22.5316 29.7367C22.3194 29.6305 22.1896 29.4092 22.2006 29.1722C22.2116 28.9351 22.3613 28.7268 22.5825 28.6408L36.9825 23.0408C37.1915 22.9595 37.4284 23.0016 37.5967 23.1499ZM30.4315 31.9831C30.4271 31.9785 30.4226 31.9739 30.4179 31.9695L30.0485 31.6L32.8242 28.8243C33.0585 28.59 33.0585 28.2101 32.8242 27.9757C32.5899 27.7414 32.21 27.7414 31.9757 27.9757L28.7757 31.1757C28.5414 31.41 28.5414 31.7899 28.7757 32.0243L29.2077 32.4563L27.807 34.3239L26.5692 30.6103C26.5188 30.4593 26.4106 30.3345 26.2683 30.2633L24.2789 29.2686L36.3366 24.5795L33.6749 35.2264L30.4315 31.9831Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSendTg);
export default __webpack_public_path__ + "static/media/step_send_tg.d83d524e8d8aa72e963e6302c2a971eb.svg";
export { ForwardRef as ReactComponent };